// 审核管理
const checkID = () => import("@/components/user/checkID");
const allAccountCompany = () =>
  import("@/components/platform/allAccountCompany");
const verifyBuss = () => import("@/components/platform/businessAuth/verify");
const withholdingAgreement = () =>
  import("@/components/platform/withholdingAgreement/withholdingAgreement");

// 工单服务
const workSheetList = () =>
  import("@/components/platform/workSheet/workSheetList/index");
const demandPool = () =>
  import("@/components/platform/workSheet/workSheetList/demandPool");
const addDemand = () =>
  import("@/components/platform/workSheet/workSheetList/addDemand");
const disposeOpinion = () => import("@/components/agreement/disposeOpinion");
const ideaDispose = () => import("@/components/agreement/ideaDispose");
// 营销管理
const coupon = () => import("@/components/platform/marketing/coupon");
const cluePushCreate = () =>
  import("@/components/platform/marketing/cluePushCreate");
const cluePushCreateSeller = () =>
  import("@/components/platform/marketing/cluePushCreate/indexSeller.vue");
const saleStatistics = () =>
  import("@/components/platform/marketing/saleStatistics");
// 商户交付
const deliveryAffirm = () =>
  import("@/components/operate/delivery/affirm/deliveryAffirm");
const deliveryManage = () =>
  import("@/components/operate/delivery/manage/deliveryManage");
const templateSet = () =>
  import("@/components/operate/delivery/template/templateSet");
// 智能标签管理
const smartTagFields = () =>
  import("@/components/operate/smartTagManage/smartTagFields/index");

export default [
  {
    path: "/user/checkID",
    meta: {
      text: "实名审核",
    },
    name: "checkID",
    component: checkID,
  },
  {
    path: "/getAllAccountCompany",
    name: "allAccountCompany",
    meta: {
      text: "入驻申请管理",
    },

    component: allAccountCompany,
  },
  {
    path: "/verifyBuss",
    name: "verifyBuss",
    meta: {
      text: "企业权限审核",
    },
    component: verifyBuss,
  },
  // 代扣协议（1.8版本）
  {
    path: "/withholdingAgreement",
    name: "withholdingAgreement",
    meta: {
      text: "代扣协议",
    },
    component: withholdingAgreement,
  },
  {
    path: "/workSheetList",
    name: "workSheetList",
    component: workSheetList,
    meta: {
      text: "工单列表",
    },
  },
  {
    path: "/demandPool",
    name: "demandPool",
    component: demandPool,
    meta: {
      text: "需求池",
    },
  },
  {
    path: "/addDemand",
    name: "addDemand",
    component: addDemand,
    meta: {
      text: "需求池",
    },
  },
  {
    path: "/disposeOpinion",
    name: "disposeOpinion",
    meta: {
      text: "意见征集",
    },
    component: disposeOpinion,
  },
  {
    path: "/ideaDispose",
    name: "ideaDispose",
    meta: {
      text: "意见处理",
    },
    component: ideaDispose,
  },
  {
    path: "/cluePushList",
    name: "coupon",
    meta: {
      text: "线索推送",
    },
    component: cluePushCreate,
  },
  // 营销中心
  {
    path: "/cluePushListSeller",
    name: "coupon",
    meta: {
      text: "线索推送",
    },
    component: cluePushCreateSeller,
  },
  {
    path: "/coupon",
    name: "coupon",
    meta: {
      text: "优惠劵",
    },
    component: coupon,
  },
  {
    path: "/saleStatistics",
    name: "saleStatistics",
    meta: {
      text: "优惠券统计",
    },
    component: saleStatistics,
  },
  {
    path: "/deliveryAffirm",
    name: "deliveryAffirm",
    meta: {
      text: "交付确认",
    },
    component: deliveryAffirm,
  },
  {
    path: "/deliveryManage",
    name: "deliveryManage",
    meta: {
      text: "交付管理",
    },
    component: deliveryManage,
  },
  {
    path: "/templateSet",
    name: "templateSet",
    meta: {
      text: "模板设置",
    },
    component: templateSet,
  },
  // 智能标签管理
  {
    path: "/smartTagFields",
    name: "smartTagFields",
    meta: {
      text: "交付确认",
    },
    component: smartTagFields,
  },
];
